import React from 'react';

import { loc } from '../../lib/loc';
import { OrderLoc } from '../../loc/order';

const EmptyItem = () => {
    return (
        <tr>
            <td style={{ padding: '70px 30px', textAlign: 'center' }} colSpan="8">
                {loc(OrderLoc.emptyOrderList)}
            </td>
        </tr>
    );
};

export default EmptyItem;
